import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "primary-gradient-bg text-center my-5 py-5" }
const _hoisted_2 = { class: "container container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-8 offset-md-2" }
const _hoisted_5 = { class: "text-white" }



export default /*#__PURE__*/_defineComponent({
  __name: 'PageTitle',
  props: {
  title: String,
  description: String
},
  setup(__props) {

const props = __props




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(__props.title), 1)
        ])
      ])
    ])
  ]))
}
}

})